import { render } from "./HeroBannerBlocksTile.vue?vue&type=template&id=79092cc7&scoped=true&ts=true"
import script from "./HeroBannerBlocksTile.vue?vue&type=script&lang=ts"
export * from "./HeroBannerBlocksTile.vue?vue&type=script&lang=ts"

import "./HeroBannerBlocksTile.vue?vue&type=style&index=0&id=79092cc7&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79092cc7"]])

export default __exports__